
var jqueryDatepicker = require('jquery-datepicker');

$(document).ready(function(e){
	if ($(document).find('.field.datepicker')){
		$(document).find('.field.datepicker').each(function(){

			// Bind datepicker to jQuery's $
			jqueryDatepicker($);

			var dom = $(this);
			var input = dom.find('input').datepicker({
				dateFormat: "dd/mm/yy",
				changeMonth: true,
				changeYear: true,
				yearRange: "-100:+0"
			});
		});
	}
});